import { getStorage, setStorage } from '@/utils/storage'
import { SCRAMBLE_ACC_PRE_STATUS, SCRAMBLE_SPEED_PRE_STATUS, SCRAMBLE_PRE_STATUS } from '@/utils/train-storage'

export default {
  /**
   * @description: 存储订单信息
   */
  setTrainOrderDetail(state, payload) {
    const {
      base_info,
      offline_refund_info,
      order_list,
      time_sequence,
      fee_info,
      coupon_info,
      other_info,
      voucher,
      approval_flow_list,
      approval_info,
      rc_info,
      remark_info,
      scramble_ticket_info,
      package_info,
    } = payload || {}

    state.orderDetail = payload
    state.base_info = base_info || {} // 基础数据
    state.offline_refund_info = offline_refund_info || {} // 私退私改数据
    state.order_list = order_list || [] // 订单列表
    state.time_sequence = time_sequence || [] // 时间序列
    state.fee_info = fee_info || [] // 费用信息
    state.coupon_info = coupon_info || {} // 券信息
    state.other_info = other_info || {} // 其他信息，包括温馨提示等信息
    state.voucher = voucher || {} //成本中心相关信息
    state.approval_flow_list = approval_flow_list || []
    state.approval_info = approval_info || null
    state.rc_info = rc_info || []
    state.remark_info = remark_info || null
    const { total_price, total_price_tip } = fee_info || {}
    state.total_info = {
      total_price: total_price,
      total_price_tip: total_price_tip
    }
    state.package_info = package_info || {}
    state.scramble_ticket_info = scramble_ticket_info || []
    const orderId = base_info?.order_id ?? ''
    if(orderId) {
      // 记录进度条
      const preAccProgressMap = getStorage(SCRAMBLE_ACC_PRE_STATUS) ?? {}
      const preAccProgress = preAccProgressMap?.[orderId] ?? 0
      const curAccProgress = (+(package_info?.status ?? 0)) * 10 + +(package_info?.sub_percent ?? 0)
      state.curProgress = curAccProgress
      if(curAccProgress && curAccProgress !== preAccProgress) setStorage({ key: SCRAMBLE_ACC_PRE_STATUS, data: { ...preAccProgressMap, [orderId]: curAccProgress}})
      
      // 记录速度档次
      const preSpeedStatussMap = getStorage(SCRAMBLE_SPEED_PRE_STATUS) ?? {};
      const preSpeedStatus = preSpeedStatussMap?.[orderId] ?? 0
      const curSpeedStatus = package_info?.status
      const {
        pre_percent,
        pre_status,
        pre_status_name,
        percent,
        status,
        status_name
      } = package_info || {};
      state.curSpeedStatus = curSpeedStatus
      state.curScramebleStatus = {
        pre_percent,
        pre_status,
        pre_status_name,
        percent,
        status,
        status_name
      };
      console.error('-----getcurSpeedStatus', curSpeedStatus, preSpeedStatus);
      if (curSpeedStatus != preSpeedStatus)
        setStorage({
          key: SCRAMBLE_SPEED_PRE_STATUS,
          data: { ...preSpeedStatussMap, [orderId]: curSpeedStatus }
        });

    } 

    // setStorage({key: 'es_h5_train_change_info', data: {changeOrderInfo}})

    // 存一下 给下单等页面使用
    // setStorage({key: 'es_h5_train_train_info', data: trainInfo})
  },

  setVourcherInfo(state, payload) {
    state.voucher = payload || {} //成本中心相关信息
  },
  setTikcetOperateDrawerStatus(state, payload) {
    state.tikcet_operate_drawer_info = payload || {}
  }
}
